import { render, staticRenderFns } from "./Repeats.vue?vue&type=template&id=19f60948&scoped=true"
import script from "./Repeats.vue?vue&type=script&lang=js"
export * from "./Repeats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f60948",
  null
  
)

export default component.exports